<template>
    <ValidationObserver ref="profileForm" tag="div" v-slot="{invalid}" class="lg:col-span-9">
        <form @submit.prevent="saveData" method="post" class="py-6 px-4 space-y-6 sm:p-6 lg:pb-8">
            <div class="flex flex-col w-full justify-between">
                <h3>Sale Banner Editor</h3>
                <p>Edit the banner that shows for sales.</p>
            </div>

            <div class="flex flex-col space-y-6 lg:flex-row lg:space-y-0 lg:space-x-12">
                <div class="flex-grow space-y-6">
                    <ValidationProvider mode="aggressive" name="short_text" rules="required" v-slot="{errors, invalid, validated}" tag="div" class="space-y-1">
                        <label for="short_text" class="text-sm">
                            Banner Short Title
                            <span class="text-leonard-disclaimer">(Small Screens)</span>
                        </label>
                        <input id="short_text" type="text" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" v-model="fields.banner_short_text">
                        <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                    </ValidationProvider>
                    <ValidationProvider mode="aggressive" name="long_text" rules="required" v-slot="{errors, invalid, validated}" tag="div" class="space-y-1">
                        <label for="long_text" class="text-sm">
                            Banner Long Title
                            <span class="text-leonard-disclaimer">(Large Screens)</span>
                        </label>
                        <input id="long_text" type="text" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" v-model="fields.banner_long_text">
                        <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                    </ValidationProvider>
                    <ValidationProvider mode="aggressive" name="button_text" rules="required" v-slot="{errors, invalid, validated}" tag="div" class="space-y-1">
                        <label for="button_text" class="text-sm">
                            Banner Button Text
                        </label>
                        <div class="flex">
                            <input id="button_text" type="text" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" v-model="fields.banner_button_text">
                        </div>
                        <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                    </ValidationProvider>
                    <ValidationProvider mode="aggressive" name="modal_header" rules="required" v-slot="{errors, invalid, validated}" tag="div" class="space-y-1">
                        <label for="modal_header" class="text-sm">
                            Details Header
                        </label>
                        <div class="flex">
                            <input id="modal_header" type="text" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" v-model="fields.banner_modal_header">
                        </div>
                        <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                    </ValidationProvider>
                    <ValidationProvider mode="aggressive" name="modal_body" rules="required" v-slot="{errors, invalid, validated}" tag="div" class="space-y-1">
                        <label for="modal_body" class="text-sm">
                            Details Body
                        </label>
                        <div class="flex">
                            <input id="modal_body" type="text" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': invalid && validated}" v-model="fields.banner_modal_body">
                        </div>
                        <p class="text-sm text-leonard-error mt-1">{{errors[0]}}</p>
                    </ValidationProvider>
                    <div class="space-y-1">
                        <div class="flex items-start">
                            <div class="flex items-center h-5">
                                <input id="show" name="show" type="checkbox" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded" v-model="fields.banner_show">
                            </div>
                            <div class="ml-3 text-sm">
                                <label for="show" class="text-sm">Show</label>
                                <p class="text-sm text-leonard-disclaimer">Activate the Banner</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-end space-x-5">
                <button type="submit"
                        class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-leonard-green border-transparent text-leonard-white hover:bg-leonard-green-hover focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed"
                        :disabled="invalid"
                >
                    Save
                </button>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend} from 'vee-validate'

import Content from '../../classes/Content'

export default {
    data() {
        return {
            Content: new Content(),
            fields: {},
        };
    },

    components: {
        ValidationProvider,
        ValidationObserver,
    },

    mounted() {
        this.getSaleBanner()
    },

    methods: {
        getSaleBanner() {
            let _this = this

            this.Content.getBanner().then(function(response) {
                if(!response.success) {
                    return
                }
                _this.fields = response.data
                _this.fields.banner_show = response.data.banner_show === 'true'
            })
        },

        saveData() {
            this.Content.saveBanner(this.fields).then(function(response) {
                if(!response.success) {
                    return
                }

                feedback('Banner Saved', 'success')
                window.events.$emit('updateBanner');
            })
        }
    },
};
</script>
